let baseUrl = window.location.protocol + "//" + window.location.host + "/";

$('a').on('click', function (e) {

    console.log($(this).prop('href'));

    var str = $(this).prop('href');
    var n = str.lastIndexOf('/');
    var result = str.substring(n + 1);

    if(result.indexOf('#popup-video-') !== -1) {
        let popupVideoId = result.replaceAll('#popup-video-', '');
        popupVideoId = popupVideoId.replaceAll(baseUrl, '');
        console.log(popupVideoId);
        $('#popup-video-modal-' + popupVideoId).modal('show');
    }

});
